import { render, staticRenderFns } from "./Garantias.vue?vue&type=template&id=1bb7a983&scoped=true"
import script from "./Garantias.vue?vue&type=script&lang=js"
export * from "./Garantias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb7a983",
  null
  
)

export default component.exports